import { getParentPath } from "features/DMS/utils/getParentPath";

export function formatDmsDocumentLink(documentPath: string) {
  const parentPath = getParentPath(documentPath);
  const searchParams = new URLSearchParams({
    action: "document-view",
    actionPath: documentPath,
  });
  return `/dms/library/v2${parentPath}?${searchParams.toString()}`;
}
